import createPlugin from './createPlugin'

import ButtonsRenderer from './Renderer/ButtonsRenderer'

const buttonsPlugin = settings =>
    createPlugin({
        Renderer: ButtonsRenderer,
        ...settings,
    })

const buttons = buttonsPlugin()
export default buttons

export { buttonsPlugin, ButtonsRenderer }
